export const API_ROUTER = {
  auth: {
    register: {
      method: 'POST',
      url: '/auth/register',
    },
    registerEvent: {
      method: 'POST',
      url: '/public/special/event/{eventName}',
    },
    logIn: {
      method: 'POST',
      url: '/auth/login',
    },
    facebookAuthCheck: {
      method: 'POST',
      url: '/auth/facebook/check',
    },
    googleAuthCheck: {
      method: 'POST',
      url: '/auth/google/check',
    },
    logOut: {
      method: 'POST',
      url: '/auth/logout',
    },
    forgotPassword: {
      method: 'POST',
      url: '/auth/password/forgot',
    },
    changePassword: {
      method: 'PUT',
      url: '/app/password/change',
    },
    confirmPassword: {
      method: 'POST',
      url: '/auth/password/confirm',
    },
    confirmEmail: {
      method: 'POST',
      url: '/public/v1/email/confirm',
    },
  },
  media: {
    get: {
      method: 'GET',
      url: '/api/v1/media',
    },
    create: {
      method: 'POST',
      url: '/api/v1/media',
    },
  },
  follow: {
    followCommunity: {
      method: 'POST',
      url: 'api/v1/follow/community',
    },
    followEvent: {
      method: 'POST',
      url: 'api/v1/follow/event',
    },
    followTournament: {
      method: 'POST',
      url: 'api/v1/follow/tournament',
    },
    followUser: {
      method: 'POST',
      url: 'api/v1/follow/user',
    },
    stopFollowCommunity: {
      method: 'DELETE',
      url: 'api/v1/follow/community/{communityId}',
    },
    stopFollowEvent: {
      method: 'DELETE',
      url: 'api/v1/follow/event/{eventId}',
    },
    stopFollowTournament: {
      method: 'DELETE',
      url: 'api/v1/follow/tournament/{tournamentId}',
    },
    stopFollowUser: {
      method: 'DELETE',
      url: 'api/v1/follow/user/{favoriteId}',
    },
    IsUserFollowCommunity: {
      method: 'GET',
      url: 'api/v1/follow/community/{communityId}',
    },
    IsUserFollowEvent: {
      method: 'GET',
      url: 'api/v1/follow/event/{eventId}',
    },
    IsUserFollowTournament: {
      method: 'GET',
      url: 'api/v1/follow/tournament/{tournamentId}',
    },
    IsUserFollowUser: {
      method: 'GET',
      url: 'api/v1/follow/user/{favoriteId}',
    },
    // TODO MAKE PAGINATION
    getfollowedCommunities: {
      method: 'GET',
      url: 'api/v1/follow/communities/{page}/{limit}',
    },
    // TODO MAKE PAGINATION
    getfollowedEvents: {
      method: 'GET',
      url: 'api/v1/follow/events/{page}/{limit}',
    },
    // TODO MAKE PAGINATION
    getfollowedTournaments: {
      method: 'GET',
      url: 'api/v1/follow/tournaments/{page}/{limit}',
    },
    getFollowedUsers: {
      method: 'GET',
      url: 'api/v1/follow/users/{page}/{limit}',
    },
  },
  events: {
    getAuthEvents: {
      method: 'GET',
      url: '/api/v1/events/{page}/{limit}',
    },
    getEvents: {
      method: 'GET',
      url: '/public/v1/events/{page}/{limit}',
    },
    getCurrentEvent: {
      method: 'GET',
      url: '/public/v1/event/{eventId}',
    },
    getEventTournaments: {
      method: 'GET',
      url: '/public/v1/event/{eventId}/tournaments/{page}/{limit}',
    },
    getEventTournamentsAuth: {
      method: 'GET',
      url: '/api/v1/event/{eventId}/tournaments/{page}/{limit}',
    },
  },
  Koza: {
    getKoza: {
      method: 'GET',
      url: '/public/v1/koza/{stageId}',
    },
  },
  user: {
    setUserAvatar: {
      method: 'POST',
      url: '/app/users/avatar',
    },
    getPublicUserInfo: {
      method: 'GET',
      url: 'public/v1/user/{userId}/profile',
    },
    getPublicUserInfoURL: {
      method: 'GET',
      url: '/public/v1/user/{userUrl}/profileByUrl',
    },
    setUserData: {
      method: 'PUT',
      url: '/api/v1/my/profile',
    },
    setProfileData: {
      method: 'PUT',
      url: '/app/v1/my/profile',
    },
    getMyData: {
      method: 'GET',
      url: '/api/v1/my/profile',
    },
    getUserData: {
      method: 'GET',
      url: '/app/me',
    },
    deleteUserGame: {
      method: 'DELETE',
      url: '/api/v1/my/game/{gameId}',
    },
    getUserReferrals: {
      method: 'GET',
      url: '/app/referrals',
    },
    getUserDataByUrl: {
      method: 'GET',
      url: 'public/v1/user/{userId}/profile',
    },
    getNewUsersAroundYou: {
      method: 'GET',
      url: '/app/users/{userUuid}/new-around-you',
    },
    search: {
      method: 'GET',
      url: '/public/user/search',
    },
    saveAddress: {
      method: 'PUT',
      url: '/app/users/address',
    },
    getUserQR: {
      method: 'GET',
      url: '/public/v1/user/{userId}/passport/qr-code',
    },
    changeUserNickname: {
      method: 'PUT',
      url: '/api/v1/my/nickname',
    },
    getUserTournaments: {
      method: 'GET',
      url: '/public/v1/user/{userId}/tournaments',
    },
    updateAccount: {
      method: 'POST',
      url: '/api/v1/update/account',
    },
    activateAccount: {
      method: 'GET',
      url: '/api/v1/resend/email',
    },
  },
  public: {
    getNewUsers: {
      method: 'GET',
      url: '/public/statistics/users/new',
    },
    getLanguages: {
      method: 'GET',
      url: '/public/labels/languages',
    },
    getCountriesList: {
      method: 'GET',
      url: '/public/labels/countries',
    },
    getCountryRegions: {
      method: 'GET',
      url: '/public/labels/countries/{country}/regions',
    },
    getCitiesByRegion: {
      method: 'GET',
      url: '/public/labels/countries/{country}/regions/{region}/cities',
    },
    getLocationByIp: {
      method: 'GET',
      url: '/public/ip/{ip}',
    },
    getPlatforms: {
      method: 'GET',
      url: '/public/catalog/platform',
    },
    getDevices: {
      method: 'GET',
      url: '/public/game/devices',
    },
  },
  games: {
    getAvailable: {
      method: 'GET',
      url: '/app/games/available',
    },
    addGameToUserGames: {
      method: 'POST',
      url: '/api/v1/my/game',
    },
    getUserGames: {
      method: 'GET',
      url: '/api/v1/my/games',
    },
    getGames: {
      method: 'GET',
      url: 'public/v1/games',
    },

    getAllowedGames: {
      method: 'GET',
      url: '/app/games/allowed',
    },
    getConnectedGames: {
      method: 'GET',
      url: '/public/v1/user/{userId}/games',
    },
    dota2: {
      getHeroesStatistic: {
        method: 'GET',
        url: '/public/users/{userUuid}/games/dota2/heroes',
      },
    },
    connect: {
      method: 'POST',
      url: '/app/games/add/{gameCode}',
    },
  },
  steam: {
    connect: {
      method: 'POST',
      url: '/app/integrations/steam/connect/{code}',
    },
    disconnect: {
      method: 'DELETE',
      url: '/app/integrations/steam',
    },
    signIn: {
      method: 'POST',
      url: '/auth/steam/sign-in',
    },
    signUp: {
      method: 'POST',
      url: '/auth/steam/sign-up',
    },
    getProfile: {
      method: 'POST',
      url: '/public/steam/profile',
    },
    getProfileDetails: {
      method: 'GET',
      url: '/app/integrations/steam/user/player-summaries/v2/{steamId}',
    },
  },
  chat: {
    getUserChats: {
      method: 'GET',
      url: '/app/chats',
    },
    createNewChat: {
      method: 'POST',
      url: '/app/chats',
    },
    getChatInfo: {
      method: 'GET',
      url: '/app/chats/{chatUuid}',
    },
    getChatMessages: {
      method: 'GET',
      url: '/app/chats/{chatUuid}/messages',
    },
    sendMessage: {
      method: 'POST',
      url: '/app/chats/{chatUuid}/messages',
    },
    deleteChat: {
      method: 'DELETE',
      url: '/app/chats/{chatUuid}',
    },
  },
  notifications: {
    getUserNotifications: {
      method: 'GET',
      url: '/app/notifications/{page}/{limit}',
    },
    markSingleAsViewed: {
      method: 'PATCH',
      url: '/app/notifications/{id}/view',
    },
    markArrayAsViewed: {
      method: 'PATCH',
      url: '/app/notifications/view',
    },
    deleteSingleNotification: {
      method: 'DELETE',
      url: '/app/notifications/{id}',
    },
  },
  friendship: {
    addFriend: {
      method: 'POST',
      url: '/app/friendship/{userUuid}',
    },
    approveRequest: {
      method: 'POST',
      url: '/app/friendship/{friendshipUuid}/approve',
    },
    declineRequest: {
      method: 'POST',
      url: '/app/friendship/{friendshipUuid}/decline',
    },
    getFriendsList: {
      method: 'GET',
      url: '/app/friendships',
    },
    getRequestsList: {
      method: 'GET',
      url: '/app/friendships/received',
    },
  },
  rating: {
    getPlayersListByGame: {
      method: 'GET',
      url: '/public/games/{game}/ratings',
    },
    getRatingTable: {
      method: 'POST',
      url: '/public/v1/rating/{page}/{limit}',
    },
  },
  external: {
    getIpAddress: {
      method: 'GET',
      url: 'https://api.ipify.org/',
    },
  },
  institutions: {
    search: {
      method: 'GET',
      url: '/app/institutions/search',
    },
    add: {
      method: 'POST',
      url: '/app/institutions',
    },
  },
  education: {
    get: {
      method: 'GET',
      url: '/app/educations',
    },
    add: {
      method: 'POST',
      url: '/app/educations',
    },
    edit: {
      method: 'PATCH',
      url: '/app/educations/{uuid}',
    },
    delete: {
      method: 'DELETE',
      url: '/app/educations/{uuid}',
    },
  },
  roster: {
    add: {
      method: 'POST',
      url: '/api/v1/team/roster',
    },
  },
  community: {
    getAuthCommunityList: {
      method: 'GET',
      url: '/api/v1/communities/{page}/{limit}',
    },
    getCommunityList: {
      method: 'GET',
      url: '/public/v1/communities/{page}/{limit}',
    },

    getCommunityDetails: {
      method: 'GET',
      url: '/public/v1/community/{communityId}',
    },
    getCommunityEventAuth: {
      method: 'GET',
      url: '/api/v1/community/{communityId}/events/{page}/{limit}',
    },
    getCommunityEvent: {
      method: 'GET',
      url: '/public/v1/community/{communityId}/events/{page}/{limit}',
    },
    getCommunityTournaments: {
      method: 'GET',
      url: '/public/v1/community/{communityId}/tournaments/{page}/{limit}',
    },
    getCommunityTournamentsAuth: {
      method: 'GET',
      url: '/api/v1/community/{communityId}/tournaments/{page}/{limit}',
    },

    getList: {
      // old
      method: 'GET',
      url: '/app/users/communities',
    },
    create: {
      // old
      method: 'POST',
      url: '/app/community',
    },
    search: {
      // old
      method: 'GET',
      url: '/app/community',
    },
    join: {
      method: 'POST',
      url: '/app/community/{uuid}/join',
    },
    leave: {
      method: 'POST',
      url: '/app/community/{uuid}/leave',
    },
    leaderboard: {
      method: 'GET',
      url: '/public/games/{gameCode}/community/{communityUuid}',
    },
    createNewCommunity: {
      method: 'POST',
      url: '/app/community',
    },
    uploadImage: {
      method: 'POST',
      url: '/app/community/{communityUuid}/image',
    },
  },
  // battles: {
  //     getBattlesList: {
  //         method: 'GET',
  //         url: '/public/battles'
  //     },
  //     getPopular: {
  //         method: 'GET',
  //         url: '/public/battles/info/popular'
  //     },
  //     getAside: {
  //         method: 'GET',
  //         url: '/public/battles/info/aside'
  //     },
  //     getBattleInfo: {
  //         method: 'GET',
  //         url: '/public/battles/{uuid}'
  //     },
  //     getParticipantBoard: {
  //         method: 'GET',
  //         url: '/public/battles/{battle}/ratings'
  //     },
  //     voteForParticipant: {
  //         method: 'POST',
  //         url: '/app/battles/{battle}/participants/{participant}/vote'
  //     }
  // },
  comparison: {
    getList: {
      method: 'POST',
      url: '/public/comparisons',
    },
  },
  getQRCode: {
    method: 'GET',
    url: '/app/users/id-pass-qr-code',
  },
  getTeamQR: {
    method: 'GET',
    url: '/public/v1/team/{teamId}/passport/qr-code',
  },
  teams: {
    getTeamByRole: {
      method: 'GET',
      url: '/public/v1/user/{userId}/{role}/teams',
    },
    createTeam: {
      method: 'POST',
      url: '/api/v1/team',
    },
    getTeams: {
      method: 'GET',
      url: '/public/v1/teams',
    },
    getTeamDetailsFromToken: {
      method: 'GET',
      url: '/public/v1/team-member-invite/{token}',
    },
    acceptTeamInviteFromToken: {
      method: 'PUT',
      url: '/public/v1/team-member-invite/{token}',
    },
    putTeam: {
      method: 'PUT',
      url: '/api/v1/team/{teamId}',
    },
    updateTeam: {
      method: 'PATCH',
      url: '/app/teams/{team}',
    },
    addTeamImage: {
      method: 'POST',
      url: '/app/teams/{teamUuid}/image',
    },
    setDesiredGames: {
      method: 'PATCH',
      url: '/app/users/me/desired-teams',
    },
    getMyRequests: {
      method: 'GET',
      url: '/app/team-requests/my',
    },

    getMyTeams: {
      method: 'GET',
      url: 'api/v1/my/teams',
    },
    postTeamGame: {
      method: 'POST',
      url: 'api/v1/team/{teamId}/game',
    },
    getTeamGames: {
      method: 'GET',
      url: 'public/v1/team/{teamId}/games',
    },
    getTeamDetails: {
      method: 'GET',
      url: 'api/v1/team/{teamId}',
    },
    getTeamPublicDetails: {
      method: 'GET',
      url: 'public/v1/team/{teamId}',
    },
    getTeamRequests: {
      method: 'GET',
      url: '/app/team/{teamUuid}/requests',
    },
    getTeam: {
      method: 'GET',
      url: '/public/v1/team/{teamUuid}',
    },
    find: {
      method: 'GET',
      url: '/app/teams',
    },
    leaveTeam: {
      method: 'POST',
      url: '/app/teams/{teamUuid}/leave',
    },
    inviteUser: {
      method: 'POST',
      url: '/app/teams/{teamUuid}/invite',
    },
    requestAccept: {
      method: 'POST',
      url: '/app/team-requests/{requestUuid}/accept',
    },
    requestCancel: {
      method: 'POST',
      url: '/app/team-requests/{requestUuid}/cancel',
    },
    movePlayer: {
      method: 'POST',
      url: '/app/team-members/{teamMember}/move',
    },
    kickPlayer: {
      method: 'POST',
      url: '/app/team-members/{teamMember}/exclude',
    },
    makeCaptain: {
      method: 'POST',
      url: '/app/team-members/{teamMember}/capitan',
    },
    referral: {
      method: 'GET',
      url: '/app/teams/referral/{referral}',
    },
    getMembersGame: {
      method: 'GET',
      url: '/public/v1/team/{teamId}/members/{gameId}',
    },
    getMembers: {
      method: 'GET',
      url: '/public/v1/team/{teamId}/members',
    },
    setEmailUserInvite: {
      method: 'POST',
      url: '/api/v1/team/{teamId}/team-member-invites',
    },
    setIdUserInvite: {
      method: 'POST',
      url: '/api/v1/team/{teamId}/team-member-invite',
    },
    delUser: {
      method: 'DELETE',
      url: '/api/v1/team/{teamId}/team-member/{userId}',
    },
    getTeamInvites: {
      method: 'GET',
      url: '/api/v1/my/team-invites',
    },
    setAnswerInvites: {
      method: 'PUT',
      url: '/api/v1/team/{teamId}/invite',
    },
  },
  tournaments: {
    getTournamentData: {
      method: 'GET',
      url: '/public/v1/tournament/{id}/grid',
    },
    getTournamentDataFFA: {
      method: 'GET',
      url: '/public/v1/tournament/{id}/ffa-grid',
    },

    getPublicMatchInfoWithUrl: {
      method: 'GET',
      url: '/public/v1/match/{number}/by-number',
    },
    getMatchInfoWithUrl: {
      method: 'GET',
      url: '/api/v1/match/{number}/by-number',
    },
    checkIdMatch: {
      method: 'POST',
      url: '/api/v1/match/check-in',
    },

    checkOutMatch: {
      method: 'POST',
      url: '/api/v1/match/check-out',
    },
    getAuthTournaments: {
      method: 'GET',
      url: '/api/v1/tournaments/{page}/{limit}',
    },
    getTournaments: {
      method: 'GET',
      url: '/public/v1/tournaments/{page}/{limit}',
    },
    getCurrentTournament: {
      method: 'GET',
      url: '/public/v1/tournament/{tournamentId}',
    },
    getAuthCurrentTournament: {
      method: 'GET',
      url: '/api/v1/tournament/{tournamentId}',
    },
    getUserCurrentTournament: {
      method: 'GET',
      url: '/public/v1/user/{userId}/tournament/{tournamentId}',
    },
    getTournamentMembers: {
      method: 'GET',
      url: '/public/v1/tournament/{tournamentId}/tournament-members',
    },
    getTournamentMatches: {
      method: 'GET',
      url: '/public/v1/tournament/{tournamentId}/matches',
    },
    getCurrentMatch: {
      method: 'GET',
      url: '/api/v1/match/{matchId}',
    },
    getMembersMatch: {
      method: 'GET',
      url: '/api/v1/match/{matchId}/members',
    },
    getMembersPublicMatch: {
      method: 'GET',
      url: '/public/v1/match/{matchId}/members',
    },
    setResultMatch: {
      method: 'PUT',
      url: '/api/v1/match-result/{matchId}',
    },
    setResultMatchFFA: {
      method: 'PUT',
      url: '/api/v1/match-result-ffa/{matchId}',
    },

    getPrimaryTournaments: {
      method: 'GET',
      url: '/public/tournaments/primary',
    },
    getTournamentDetails: {
      method: 'GET',
      url: '/public/tournaments/{tournamentUuid}',
    },
    getStageList: {
      method: 'GET',
      url: '/app/tournament/{tournament}/stage',
    },
    joinTournament: {
      method: 'POST',
      url: '/app/tournament/{tournament}/member/{member}',
    },
    createStage: {
      method: 'POST',
      url: '/app/tournament/{tournament}/stage',
    },
    getMatchDetails: {
      method: 'GET',
      url: '/app/tournament/stage/match/{matchUuid}',
    },
    deleteTournamentMember: {
      method: 'DELETE',
      url: '/api/v1/tournamentMember/{tournamentMemberId}',
    },
    userReady: {
      method: 'POST',
      url: '/app/tournament/stage/match/ready/{matchUuid}',
    },
    polls: {
      getPoll: {
        method: 'GET',
        url: '/app/polls/{poll}',
      },
      ban: {
        method: 'POST',
        url: '/app/poll-options/{option}/ban',
      },
      pick: {
        method: 'POST',
        url: '/app/poll-options/{option}/pick',
      },
    },
    startMatch: {
      method: 'POST',
      url: '/app/tournament/stage/match/cs/{csMatchUuid}',
    },
    getStageRounds: {
      method: 'GET',
      url: '/app/tournament/stage/{stage}/round',
    },
    getPrimaryMembers: {
      method: 'GET',
      url: '/api/v1/my/team/primary',
    },
    postTeamRoster: {
      method: 'POST',
      url: '/api/v1/tournament/{tournamentId}/tournament-member',
    },
    setRoundSettings: {
      method: 'PUT',
      url: '/api/v1/round/{roundId}',
    },
  },
  watch: {
    getAllMatchesPublic: {
      method: 'GET',
      url: '/public/v1/matches/{page}/{limit}',
    },
    getAllMatches: {
      method: 'GET',
      url: '/api/v1/matches/{page}/{limit}',
    },

    // getMyMatches: {
    //   method: "GET",
    //   url: "/api/v1/my-matches",
    // },
  },
  support: {
    method: 'POST',
    url: '/public/v1/contact',
  },
}
